import { Router } from './Router.js';
import { routerManager } from './routerManager.js';

/**
 * @param {Router} router
 */
export const setRouter = router => {
  routerManager.router = router;
};